import React from 'react';
import './hero-nav.scss';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import history from '../../../hb-redux-store/history';

const HeroNav = props => {
  const {
    showBack,
    showInfo,
    onInfoClick,
    title,
    navTitle,
    cleanNav,
    heroImageSrc,
    heroImageIcon,
  } = props;
  const goBack = () => {
    history.goBack();
  };
  return (
    <div className="hero-nav">
      <div className={`hero-nav--secondary-nav ${cleanNav ? 'clean-nav' : ''}`}>
        <div>
          {showBack && (
            <Icon
              size={24}
              class="icon-back-bar-back-white back"
              onClick={goBack}
            />
          )}
          {navTitle && (
            <div className="hero-nav--secondary-nav--nav-title">{navTitle}</div>
          )}
        </div>
        {showInfo && (
          <Icon
            size={24}
            class="icon-referral-info info"
            onClick={onInfoClick}
          />
        )}
      </div>
      {heroImageIcon && (
        <Icon size={150} class={`${heroImageIcon} hero-image`} />
      )}
      {heroImageSrc && (
        <Icon size={150} class={`hero-image`} src={heroImageSrc} />
      )}
      <div className="title">
        <div className="title--text">{title}</div>
      </div>
    </div>
  );
};
HeroNav.defaultProps = {
  showBack: true,
  showInfo: true,
  onInfoClick: () => {},
};

HeroNav.propTypes = {
  showBack: PropTypes.bool,
  showInfo: PropTypes.bool,
  onInfoClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  titleIconClass: PropTypes.string,
  navTitle: PropTypes.string,
  cleanNav: PropTypes.bool,
  heroImageSrc: PropTypes.string,
  heroImageIcon: PropTypes.string,
};

export default HeroNav;
